import React from 'react'
import AvaibleMeals from './AvaibleMeals'
import MealsSummery from './MealsSummery'

function Meals() {
  return (
    <>
    < MealsSummery />
    <AvaibleMeals />
    </>
  )
}

export default Meals